<template>
    <div>
        <b-row>
            <b-col v-for="mes in 12" :key="mes" md=4
                style="
                    padding-right: 5px;
                    padding-left: 5px;
                "
            >
                <quadro-dados
                    :titulo="meses[mes]"
                    :dados="obterMesPorCompetencia(mes)"
                    :nomesDados="nomesDados"
                    :tiposDados="tiposDados"
                    :descricoes="descricoes"
                ></quadro-dados>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import QuadroDados from '../componentes/QuadroDados.vue';

export default {
    components: {
        QuadroDados
    },

    data() {
        return {
            nomesDados: {
                totalEnviadasAnalise: 'Recebidas para análise',
                totalAprovadasUABS: 'Processos aprovados',
                mediaAprovacaoUABS: 'Média de análise UABS',
                valorTotalAprovadasUABS: 'Valor total de aprovações',
                totalReprovadasUABS: 'Processos reprovados',
                mediaReprovacaoUABS: 'Média de reprovações',
                totalConcluidas: 'Processos faturados',
                mediaConclusao: 'Média de faturamento',
                totalQuitacoes: 'Processos quitados',
                mediaQuitacao: 'Tempo médio para quitação',
            },
            tiposDados: {
                mediaAprovacaoUABS: 'media',
                mediaReprovacaoUABS: 'media',
                mediaConclusao: 'media',
                mediaQuitacao: 'media',
                valorTotalAprovadasUABS: 'money',
                totalEnviadasAnalise: 'qtd',
                totalAprovadasUABS: 'qtd',
                totalReprovadasUABS: 'qtd',
                totalConcluidas: 'qtd',
                totalQuitacoes: 'qtd',
            },
            descricoes: {
                totalEnviadasAnalise: 'Quantidade de pagamentos recebidos para análise da UABS neste mês',
                totalAprovadasUABS: 'Quantidade de processos aprovados',
                mediaAprovacaoUABS: 'Tempo médio desde o recebimento até a aprovação da UABS',
                valorTotalAprovadasUABS: 'Valor total dos pagamentos aprovados pela UABS',
                totalReprovadasUABS: 'Protocolos que já foram reprovados, ao menos 1 vez, pela UABS',
                mediaReprovacaoUABS: 'Média, em dias, de reprovações dos pagamentos pela UABS',
                totalConcluidas: 'Quantidade de processos faturados pela UFI',
                mediaConclusao: 'Tempo médio de faturamento pela UFI',
                totalQuitacoes: 'Quantidade de processos quitados neste mês',
                mediaQuitacao: 'Tempo médio desde o faturamento até a quitação do processo',
            },
            meses:['', 'Janeiro', 'Fevereiro', 'Março', 'Abril',
                'Maio', 'Junho', 'Julho', 'Agosto',
                'Setembro', 'Outubro', 'Novembro', 'Dezembro'
            ]
        }
    },

    props: {
        estatisticas: {
            type: Array,
            default: () => []
        },

        ano: {
            type: Number
        },
    },

    methods: {
        obterMesPorCompetencia(mes){
            let dados = this.estatisticas.find(p => parseInt(this.$moment(p.competencia).format('MM')) == mes)
            return dados
        }
    },

    computed: {

    }
}

</script>